import './NavBar.css'



const NavBar=()=>{
    return(
    <div id='NavBar'>
        <div className="NavAbout">
            <a href="#" className='NavAboutBTN a'>
                <img src="/assets/about.png" alt="About" />
            </a>
        </div>
        <div className='NavLogo'>
            <a href="#" className='a'>
                miusic
            </a>
        </div>
        <div  className='NavSearch'>
            
                <button className='AearchButton'>
                    <img src="/assets/search.png" alt="" />
                </button>
                <input type="search" className='NavSearchBox' placeholder='جست و جو ...' />
            
        </div>
    </div>
    )
}

export default NavBar